import React from 'react'
import Fragment from '../common/fragment'


function FragmentBX(props) {
  return (
    <Fragment pos="xx" {...props}>
      <p>
      “Cuadrado negro sobre fondo blanco” (Kasimir Malevich)
      </p>
    </Fragment>
  )
}


export default FragmentBX
